import styled from "styled-components";
import React from "react";
import {tableBorderColour} from "../../../../style/styleConsts";
import {PortfolioActions} from "./PortfolioActions";

const Container = styled.div`
    width: 360px;
    flex-shrink: 0;
`;

const ClosedForAll = styled.div`
    font-weight: bold;
    margin-bottom: 1ex;
`;

const ActionDetail = styled.div`
    position: relative;
    .action {
      background: ${tableBorderColour};
      position: absolute;
      left: 0;
      top: 0;
      font-weight: bold;
      padding: 1px 0;
      border-radius: 4px;
      width: 80px;
      text-align: center;
      display: inline-block;
      font-size: 12px;
    }
    .portfolios {
      margin-left: 90px;
    }
`;

export const ActionHeader = () => {
    return <Container className="t-action-header">Action</Container>;
};

const PortfolioActionsContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ActionCell = ({activity: {action, portfolios}, activityId, closedForAll, ideaActions, expanded}) => (
    <Container>
        {
            closedForAll ? <ClosedForAll className="t-closed-for-all">Idea closed for all your clients</ClosedForAll>
                         : null
        }
        <ActionDetail>
            <span className="action t-action">{action}</span>
            <PortfolioActionsContainer className="portfolios t-portfolios">
                <PortfolioActions activityId={activityId} action={action}
                                  portfolios={portfolios}
                                  ideaActions={ideaActions}
                                  expanded={expanded.contains(activityId)}/>
            </PortfolioActionsContainer>
        </ActionDetail>
    </Container>
);